// extracted by mini-css-extract-plugin
export default {"Container":"Error_Container__sxV9i","Title":"Error_Title__T8CXY","Message":"Error_Message__HXv3x"};